export default {
	GET_ALL: (crewId) => `/houseItem/category/all?crewId=${crewId}`,
	CREATE: (crewId) => `/houseItem/category?crewId=${crewId}`,
	UPDATE: (id) => `/houseItem/category/${id}`,
	DELETE: (id) => `/houseItem/category/${id}`,
};
